import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { makeStyles } from '@mui/styles';
import { formInitialize, formDestroy, formSubmitAPI } from '../../../reducers/form';
import { getMaterials } from '../../../api/material'
import { updMOPById } from "../../../api/doc";
// import { fetchDispath } from '../../../functions/fetch'
import {
  loadAutocompliteAPI, initialAutocomplite, set as setAutocomplite,
  clearAutocomplite, addFilterManyAutocomplite
} from '../../../reducers/autocomplite'
import { enqueueSnackbar } from '../../../reducers/notifier';
import DocTable from '../../../components/DocTable'
import DocAdd from '../../../components/DocAdd'
import FilesTab from './source/FilesTab'
import moment from 'moment'
import { loadProvider, addProvider } from '../../../api/list'
import { statusAll } from './source/type.enum'
import * as actions from '../../../reducers/form';
import * as actionsAuto from '../../../reducers/autocomplite'
import { TableCell, Select, Button, Grid } from '@mui/material';
import { getMSN, addMSNfunction } from '../../../api/material'
import AutoCompliteCreate from '../../../components/AutocompliteCreate'
import AutoComplite from '../../../components/Autocomplite'

import DialogAddEntera from './source/DialogAddEntera'
import { nds } from '../../../enum/nds.enum'
import AllPrice from '../shipmentMaterial/add/source/AllPrice'
import CompaniesAdd from '../../list/provider/ProviderAdd'
import { fetchDispath } from '../../../functions/fetch'
import { getMOPById } from "../../../api/doc";

const formName = 'outfitPlan'
const formNameEntera = 'outfitPlanEntera'
const formMaterial = 'material'
const formCopy = 'MOP_Copy'


export default function OrderProviderEdit(props) {
  const dispatch = useDispatch()
  const idProject = props.match.params.idProject
  const [entera, setEntera] = useState(false)
  const [idEntera, setIdEntera] = useState(null)
  useEffect(() => {
    dispatch(formInitialize({
      dateOrder: moment(Date.now()).format('YYYY-MM-DD'),
      status: '',
      title: '',
      nds: '',
      idProvider: 0,
      mById: {}, // Table material
      mAllIds: [], // Table material
      fById: {}, // Table files
      fAllIds: [], // Table files
    }, { name: formName }))
    dispatch(initialAutocomplite({ field: formMaterial }))
    dispatch(initialAutocomplite({ field: formNameEntera }))
    return () => {
      dispatch(formDestroy({ name: formName }))
      dispatch(formDestroy({ name: formCopy }))
      dispatch(clearAutocomplite({ field: formMaterial }))
      dispatch(clearAutocomplite({ field: formNameEntera }))
    }
  }, [dispatch])

  useEffect(() => {
    const pathMaterials = getMaterials.path({ id: idProject }) + '?type=balance'
    const metaMaterials = {
      field: formMaterial,
      value: 'id',
      hidden: ['storageUnit', 'idStorageUnit', 'storage', 'count', 'balance'],
      labelFunc: (obj) => obj.name + ' ' + obj.typeMark + ' ' + obj.vendorCode
    }
    dispatch(loadAutocompliteAPI(pathMaterials, metaMaterials))
  }, [dispatch, idProject])

  const material = useSelector(state => state.autocomplite[formMaterial] || state.autocomplite.default)

  useEffect(() => {
    if (!material.load) return;
    let newId = 0
    let objAdd = {}
    let arrAdd = []
    let filterAdd = []
    dispatch(fetchDispath({
      param: {
        idProject: props.match.params.idProject,
        id: props.match.params.idDoc
      },
      progress: true,
      request: getMOPById,
    }))
      .then((res) => {
        if (!res) return;
        res.get.table.forEach((obj, i) => {
          const findMaterial = material.arr.find(e => obj.idMaterial.toString() === e.value)
          if (!findMaterial) return;
          newId += 1
          objAdd['id-' + newId] = {
            id: findMaterial.value,
            count: obj.count,
            storageUnit: findMaterial.storageUnit,
            storage: findMaterial.storage,
            value: findMaterial,
            nds: obj.nds,
            price: obj.price,
            summ: Math.round(obj.count * obj.price * 100) / 100,
            summNDS: Math.round(obj.count * obj.price * 100 * ((obj.nds === 'NDS20') ? 1.2 : 1)) / 100,
            balance: findMaterial.balance,

            idEstimate: obj.idEstimate,
            valueEstimate: obj.idEstimate ? {
              value: obj.idEstimate,
              label: obj.providerName
            } : null,
            estimateName: obj.providerName,
            valueEntera: null
          }
          arrAdd.push('id-' + newId)
          filterAdd.push({ value: findMaterial.value, id: 'id' + newId })
        })
        dispatch(addFilterManyAutocomplite(filterAdd, { field: formMaterial }))
        dispatch(setAutocomplite({ value: res.get.header.idProvider.toString(), label: res.get.header.provider }, { field: 'provider' }))
        let fById = {}
        const fAllIds = res.get.files.map(e => {
          newId += 1
          fById['id-' + newId] = {
            id: e.id, name: e.originalName, type: e.type
          }
          return 'id-' + newId
        })
        dispatch(actions.formChangeAsObj({
          mAllIds: arrAdd,
          mById: objAdd,
          idRow: newId,
          status: res.get.header.status,
          title: res.get.header.title,
          dateOrder: moment(res.get.header.dateOrder).format('YYYY-MM-DD'),
          idProvider: res.get.header.idProvider,
          fById: fById,
          fAllIds: fAllIds,
        }, { name: formName }))
      })
  }, [dispatch, material.load, props.match.params.idDoc, props.match.params.idProject])

  const form = useSelector(state => state.form[formName] || state.form.default)
  const { values } = form

  const handleEdit = () => {
    const { mById, mAllIds, fById, dateOrder, status, idProvider, title } = values
    const arrMaterial = mAllIds.map(e => {
      const obj = mById[e]
      let ret = {
        id: obj.id,
        count: obj.count,
        price: obj.price,
        nds: obj.nds,
        nameEstimate: obj.nameEstimate,
        idEstimate: obj.idEstimate
      }
      return ret
    })
    if (mAllIds.filter(e => mById[e].count === '').length > 0) {
      dispatch(enqueueSnackbar({
        message: `не заполнено количество материалов`,
        options: { variant: 'error' }
      }))
      return;
    }
    dispatch(formSubmitAPI({
      props: {
        dateOrder,
        status,
        title,
        idProvider,
        material: arrMaterial,
        files: Object.values(fById).map(e => ({ id: e.id, type: e.type })),
        idProject: idProject,
        idDocOcr: idEntera
      },
      url: updMOPById.path({ id: props.match.params.idDoc }),
      method: updMOPById.type,
      history: props.history
    }))
  }
  const handleChangeNDS = (id, count, price, obj) => {
    const summ = Math.round(count * price * 100) / 100
    const summNDS = Math.round(count * price * 100 * ((obj.nds === 'NDS20') ? 1.2 : 1)) / 100
    dispatch(actions.formObjChangeObj({ summ, summNDS }, { field: 'mById', id: id, name: formName }))
  }
  const getSumm = () => {
    if (!values.mAllIds) return 0
    let s = 0;
    values.mAllIds.forEach(e => {
      const obj = values.mById[e]
      s += obj.summNDS
    })
    return s;
  }
  let summ = getSumm();
  return <div className='App-paper'>
    <DocAdd
      headerButton={<DialogAddEntera idProject={idProject} formName={formName} setEntera={(id) => { setIdEntera(id); setEntera(true) }} isEdit={true} />}
      formName={formName}
      history={props.history}
      title='Изменить заказ'
      tab={['Материалы', 'Файлы']}
      noTableProps={[
        {
          field: 'title',
          label: 'Описание',
          type: 'text',
          xs: 6
        },
        {
          field: 'idProvider', label: 'Поставщик', type: 'autoLoadCreateModal',
          textProps: {
            createAPI: addProvider,
            createBody: 'name',
            path: loadProvider.path,
            meta: {
              field: 'provider',
              value: 'id',
              labelFunc: (obj) => obj.name + ' ' + obj.inn || ''
            },
            modal: ({ handleClose }) => <CompaniesAdd history={props.history} modal={true} modalClose={handleClose} />
          }, xs: 4,
        },
        {
          field: 'status',
          label: 'Статус',
          type: 'autoArr',
          textProps: {
            arr: statusAll
          }, xs: 3
        },
        {
          field: 'ndsDefault',
          label: 'НДС',
          type: 'autoArr',
          textProps: {
            arr: nds
          }, xs: 3
        },
        { field: 'dateOrder', label: 'Желаемая дата поставки', type: 'text', textProps: { type: 'date' }, xs: 3 },
      ]}
      handleSave={handleEdit}
      bottom={<AllPrice summ={summ || 0} />}
    >
      <DocTable
        formName={formName}
        byIdField='mById'
        allIdsField='mAllIds'
        column={[
          {
            id: 'value', type: 'auto', name: 'Материал смет', formArr: formMaterial, width: '25%', filtered: true, grouped: false,
            changeValue: text => {
              return ({
                value: text,
                balance: text.balance,
                storageUnit: text.storageUnit,
                id: text.value,
                storage: text.storage,
                idEstimate: null,
                valueEstimate: null,
              })
            }
          },
          { id: 'idEstimate', type: 'component', name: 'Материал поставщика', component: MaterialComponent, componentProps: { idProject } },
          {
            id: 'count', type: 'number', name: 'Количество',
            textProps: obj => {
              return ({ error: obj.count > obj.balance, helperText: obj.count > obj.balance ? 'Больше чем в смете' : '' })
            },
            change: ({ value, id, obj }) => { handleChangeNDS(id, value, obj.price, obj) }
          },
          { id: 'storageUnit', type: 'string', name: 'Ед.изм' },
          { id: 'balance', type: 'string', name: 'По смете', width: '10%', },
          { id: 'storage', type: 'string', name: 'На складе' },
          { id: 'price', type: 'number', name: 'Цена за ед.', change: ({ value, id, obj }) => { handleChangeNDS(id, obj.count, value, obj) } },
          { id: 'nds', type: 'component', name: 'НДС', component: SelectSwitch, componentProps: { idProject } },
          { id: 'summ', type: 'string', name: 'Сумма' },
          { id: 'summNDS', type: 'string', name: 'Сумма с НДС' },
        ].filter(e => e)}
        rowDefault={{
          id: '',
          count: 0,
          storageUnit: '',
          storage: '',
          value: '',
          nds: values.ndsDefault || '',
          price: 0,
          summ: 0,
          summNDS: 0,
          valueEntera: null
        }}
      />
      <FilesTab formName={formName} />

    </DocAdd>
  </div>
}

const useStyles = makeStyles({
  formControl2: {
    width: 240,
  },
});

function MaterialComponent({ obj, value, formName, idProject, byIdField, id }) {
  const classes = useStyles();
  const dispatch = useDispatch()
  const [idMaterial, setIdMaterial] = useState('')
  const [allAutoArr, setAllAutoArr] = useState([])
  const [serverEdit, setServerEdit] = useState(false)
  const [enteraEdit, setEnteraEdit] = useState(false)
  const [,] = useState()
  const autoAll = useSelector(state => state.autocomplite)
  const auto = autoAll['estimate' + idMaterial]
  const autoEntera = autoAll[formNameEntera] || autoAll.default
  const loadAuto = Boolean(auto?.load)
  useEffect(() => {
    if (!obj.id || obj.id === '' || idMaterial === obj?.id) return
    setIdMaterial(obj?.id)

  }, [idMaterial, obj?.id])
  useEffect(() => {
    if (!idMaterial || idMaterial === '' || loadAuto) return
    dispatch(actionsAuto.loadAutocompliteAPI(getMSN.path({ id: idProject, idMaterial: idMaterial }), {
      field: 'estimate' + idMaterial,
      value: 'id',
      labelFunc: (obj) => obj.name
    }))
      .then(e => {
        setAllAutoArr(old => ([...old, 'estimate' + idMaterial]))
      })
  }, [dispatch, idMaterial, idProject, loadAuto])
  useEffect(() => {
    return () => {
      allAutoArr.forEach(field => {
        dispatch(actionsAuto.clearAutocomplite({ field: field }))
      })
    }
  }, [dispatch, allAutoArr])
  const handleChange = (text) => {
    dispatch(actions.formObjChangeObj({ idEstimate: text.value, valueEstimate: text, estimateName: text.label }, { field: byIdField, id: id, name: formName }))
    setServerEdit(false)
  }
  const handleChangeEntera = (text) => {
    const findOld = auto.arr.find(e => e.label === text.label)
    const newObj = {
      idEstimate: null,
      valueEstimate: null,
      valueEntera: text,
      estimateName: text.label,
      count: Number(text.count),
      storageUnit: obj.storageUnit === text.storageUnit ? text.storageUnit : <span style={{ color: 'red' }}>{`смета:${obj.storageUnit}  расп.:${text.storageUnit}`}</span>,
      nds: text.nds,
      summ: text.summ,
      summNDS: text.summNDS,
      price: text.price,
    }
    if (findOld) {
      newObj.idEstimate = findOld.value
      newObj.valueEstimate = findOld
      dispatch(actions.formObjChangeObj(newObj, { field: byIdField, id: id, name: formName }))
      setEnteraEdit(false)
    }
    else {
      dispatch(fetchDispath({
        body: {
          name: text.label,
        },
        progress: false,
        request: addMSNfunction(idProject, obj.id),
      }))
        .then((res) => {
          if (res.success) {
            const findNew = { value: res.data.id + '', label: text.label }
            dispatch(actionsAuto.add(findNew, { field: 'estimate' + idMaterial }))
            newObj.idEstimate = findNew.value
            newObj.valueEstimate = findNew
            dispatch(actions.formObjChangeObj(newObj, { field: byIdField, id: id, name: formName }))
            setEnteraEdit(false)
          }
        })
    }
  }
  const createNew = (inputValue) => {
    return dispatch(fetchDispath({
      body: {
        name: inputValue,
      },
      progress: false,
      request: addMSNfunction(idProject, obj.id),
    }))
      .then((res) => {
        if (res.success) {
          dispatch(actionsAuto.add({ value: res.data.id + '', label: inputValue }, { field: 'estimate' + idMaterial }))
          return { success: true, obj: { value: res.data.id + '', label: inputValue } }
        }
        return { success: false }
      })
  }
  if (!idMaterial || idMaterial === '') return <TableCell key={id + 'idEstimate'}></TableCell>
  const valueAuto = obj?.idEstimate ? { value: obj.idEstimate, label: obj.estimateName } : null
  return <TableCell key={id + 'idEstimate'}>
    <div className={classes.formControl2}>
      <Grid>
        <Grid>{(obj?.idEstimate) ? obj.estimateName : 'не назначено'}</Grid>
        <Grid>
          {
            serverEdit
              ? <div className={classes.formControl2}>
                <AutoCompliteCreate
                  arr={auto?.arr || []}
                  action={handleChange}
                  palaceHolder=''
                  value={valueAuto}
                  create={createNew}
                  selectProps={{
                    onBlur: () => setServerEdit(false),
                    autoFocus: true
                  }}
                  textFieldProps={{}}
                />
              </div>
              : <Button onClick={() => setServerEdit(true)}>Сохраненное ранее</Button>
          }
        </Grid>
        <Grid>
          {
            enteraEdit
              ? <div className={classes.formControl2}>
                <AutoComplite
                  arr={autoEntera?.arr || []}
                  action={handleChangeEntera}
                  palaceHolder=''
                  value={obj?.valueEntera ? obj.valueEntera : null}
                  selectProps={{
                    onBlur: () => setEnteraEdit(false),
                    autoFocus: true
                  }}
                  textFieldProps={{}}
                />
              </div>
              : <Button onClick={() => setEnteraEdit(true)}>Из распознанных</Button>
          }
        </Grid>
      </Grid>
    </div>
  </TableCell>
}

function SelectSwitch({ obj, value, formName, id, byIdField }) {
  const dispatch = useDispatch()
  const handleChange = (e) => {
    const summ = Math.round(obj.count * obj.price * 100) / 100
    const summNDS = Math.round(obj.count * obj.price * 100 * ((e.target.value === 'NDS20') ? 1.2 : 1)) / 100
    dispatch(actions.formObjChangeObj({ nds: e.target.value, summ, summNDS }, { field: byIdField, id: id, name: formName }))
  }
  return <TableCell key={id + 'nds'}>
    <Select
      native
      variant="standard"
      value={value}
      onChange={handleChange}
      style={{ minWidth: 120 }}
    >
      {nds.map(el => {
        return <option key={el.value} value={el.value}>{el.label}</option>
      })}
    </Select>
  </TableCell>
}